// extracted by mini-css-extract-plugin
module.exports = {"select-with-icon-option":"select-with-icon__select-with-icon-option___3gdxU","label":"select-with-icon__label___2VQes"};